export default __webpack_public_path__ + "static/media/Chef-4.9b66dc27.jpg";